import { PoliciesDataType } from 'domain/shared/compliance';
import { isComplianceRegistryItemNotSigned, isRegistryItemNew } from '../complianceRegistryPortalRules';

export type ComplianceDocumentNotificationContent = {
  title: string;
  description: string;
  actionLabel: string;
};

export const getComplianceDocumentNotificationContent = (
  compliance: PoliciesDataType,
): ComplianceDocumentNotificationContent | null => {
  const complianceName = compliance.complianceName || compliance.policyType;

  if (isComplianceRegistryItemNotSigned(compliance)) {
    return {
      title: `Unsigned ${complianceName} document`,
      description: `Version ${compliance.policyVersion} is waiting for your signature.`,
      actionLabel: 'Review and sign',
    };
  }

  if (isRegistryItemNew(compliance)) {
    return {
      title: `New ${complianceName} document`,
      description: `Version ${compliance.policyVersion} is available for your review.`,
      actionLabel: 'View',
    };
  }

  return null;
};
